<div class="auth">
  <div class="auth__glow" aria-hidden="true"></div>

  <header class="auth__top">
    <a routerLink="/" class="auth-brand" aria-label="PulseWatch home">
      <span class="auth-brand__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64"><path d="M9 35h11l5-12 8 24 6-17 3 5h13" /></svg>
      </span>
      <span class="auth-brand__name">PulseWatch</span>
    </a>
    <a routerLink="/knowledge-base" class="auth__help">Help</a>
  </header>

  <main class="auth__main auth__main--single">
    <section class="auth-card">
      @if (disabled()) {
        <div class="auth-success" role="alert" data-testid="forgot-disabled">
          <div class="auth-success__icon"><i class="bx bx-lock-alt"></i></div>
          <h1>Password resets are turned off</h1>
          <p>Resetting passwords is not possible at the moment. Please contact support.</p>
        </div>
        <a routerLink="/login" class="auth-btn auth-btn--ghost">Back to log in</a>
      } @else if (submitted()) {
        <div class="auth-success" role="status" data-testid="forgot-sent">
          <div class="auth-success__icon"><i class="bx bx-envelope"></i></div>
          <h1>Check your inbox</h1>
          <p>If an account exists for <strong>{{ form.value.username }}</strong>, we've sent a link to reset your password.</p>
        </div>
        <a routerLink="/login" class="auth-btn auth-btn--ghost">Back to log in</a>
      } @else {
        <h1>Reset your password</h1>
        <p class="auth-card__sub">Enter your email and we'll send you a link to choose a new one.</p>

        <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <label class="auth-field">
            <span>Email</span>
            <div class="auth-field__box" [class.is-invalid]="has('required') || has('email')">
              <i class="bx bx-envelope" aria-hidden="true"></i>
              <input type="email" formControlName="username" data-testid="forgot-email" placeholder="you@company.com" autocomplete="email" inputmode="email" />
            </div>
            @if (has('required')) {
              <small class="auth-field__error">Email is required.</small>
            } @else if (has('email')) {
              <small class="auth-field__error">Please enter a valid email address.</small>
            }
          </label>

          <button type="submit" class="auth-btn" [disabled]="isLoading()" data-testid="forgot-submit">
            @if (isLoading()) {
              <span class="auth-btn__spinner" aria-hidden="true"></span> Sending…
            } @else {
              Send reset link <i class="bx bx-right-arrow-alt"></i>
            }
          </button>
        </form>

        <p class="auth-card__alt">Remembered it? <a routerLink="/login" class="auth-link">Back to log in</a></p>
      }
    </section>
  </main>

  <footer class="auth__footer">{{ versions.hash }} · {{ versions.date | date: 'short' }}</footer>
</div>
